import { Link, NavLink } from 'react-router-dom';
import { Menu, X, LogOut } from 'lucide-react';
import { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export const CANDIDATE_NAV_ITEMS = [
  { name: 'Find Jobs', path: '/find-jobs' },
  { name: 'My Jobs', path: '/my-jobs' },
  { name: 'Documents', path: '/documents' },
  { name: 'Master Profile', path: '/master-profile' },
  { name: 'Account & Privacy', path: '/account-privacy' },
];

function navClass({ isActive }) {
  return `inline-flex min-h-[44px] items-center border-b-2 px-1 text-sm font-medium transition-[border-color,color,transform] duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#3B82F6] hover:-translate-y-0.5 ${isActive ? 'border-[#B7F34A] text-[#10231D]' : 'border-transparent text-[#65736A] hover:border-[#B7F34A] hover:text-[#10231D]'}`;
}

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user, signOut } = useAuth();

  const handleSignOut = async () => {
    await signOut();
    setMobileMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-[#D7C9AF] bg-[#FFFDF8]/95 shadow-[0_6px_20px_rgba(16,35,29,0.05)] backdrop-blur" data-testid="header">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <div className="flex min-h-20 items-center justify-between gap-4">
          <Link to={user ? '/my-jobs' : '/'} className="flex min-h-[44px] items-center gap-2" data-testid="logo-link">
            <span className="font-serif-display text-2xl font-medium tracking-tight">JobMatch<span className="italic">Pro</span></span>
          </Link>

          <nav className="hidden items-center gap-5 lg:flex" aria-label="Primary" data-testid="desktop-nav">
            {user ? CANDIDATE_NAV_ITEMS.map((item) => (
              <NavLink key={item.name} to={item.path} className={navClass} data-testid={`nav-${item.name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}>
                {item.name}
              </NavLink>
            )) : (
              <NavLink to="/find-jobs" className={navClass} data-testid="nav-find-jobs">Find Jobs</NavLink>
            )}
            {user ? (
              <button type="button" onClick={handleSignOut} className="inline-flex min-h-[44px] items-center gap-1.5 text-sm font-medium text-[#65736A] transition-[color,transform] duration-150 hover:-translate-y-0.5 hover:text-[#10231D] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#3B82F6]" data-testid="nav-sign-out">
                <LogOut className="h-4 w-4" aria-hidden="true" /> Sign Out
              </button>
            ) : (
              <Link to="/sign-in" className="btn-secondary inline-flex items-center px-4 text-sm font-medium" data-testid="nav-sign-in">Sign In</Link>
            )}
          </nav>

          <button type="button" className="inline-flex min-h-[44px] min-w-[44px] items-center justify-center rounded-md transition-[background-color,transform] duration-150 hover:bg-[#ECE7DC] active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#3B82F6] lg:hidden" onClick={() => setMobileMenuOpen((open) => !open)} data-testid="mobile-menu-btn" aria-label="Toggle menu" aria-expanded={mobileMenuOpen}>
            {mobileMenuOpen ? <X className="h-6 w-6" aria-hidden="true" /> : <Menu className="h-6 w-6" aria-hidden="true" />}
          </button>
        </div>

        {mobileMenuOpen && (
          <nav className="grid gap-2 border-t border-[#D7C9AF] bg-[#FFFDF8] py-4 shadow-[0_16px_36px_rgba(16,35,29,0.10)] animate-fade-in-up lg:hidden" aria-label="Mobile primary" data-testid="mobile-nav">
            {(user ? CANDIDATE_NAV_ITEMS : [{ name: 'Find Jobs', path: '/find-jobs' }]).map((item) => (
              <NavLink key={item.name} to={item.path} onClick={() => setMobileMenuOpen(false)} className="flex min-h-[48px] items-center rounded-md border border-[#D7C9AF] bg-white/45 px-4 text-sm font-medium text-[#10231D] transition-[background-color,transform,border-color] duration-150 hover:bg-[#ECE7DC] active:scale-[0.99]" data-testid={`mobile-nav-${item.name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}>
                {item.name}
              </NavLink>
            ))}
            {user ? (
              <button type="button" onClick={handleSignOut} className="flex min-h-[48px] items-center rounded-md border border-[#D7C9AF] bg-white/45 px-4 text-left text-sm font-medium text-[#10231D] transition-[background-color,transform] duration-150 hover:bg-[#ECE7DC] active:scale-[0.99]" data-testid="mobile-nav-sign-out">Sign Out</button>
            ) : (
              <Link to="/sign-in" onClick={() => setMobileMenuOpen(false)} className="flex min-h-[44px] items-center border border-[#22362f] px-4 text-sm font-medium" data-testid="mobile-nav-sign-in">Sign In</Link>
            )}
          </nav>
        )}
      </div>
    </header>
  );
}